import React from 'react'

export const FlagENSvg = ({size = 16, ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      width={size}
      height={size}
      enableBackground="new 0 0 512 512"
      version="1.1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      {...props}
    >
      <circle cx="256" cy="256" r="256" fill="#F0F0F0"></circle>
      <g fill="#0052B4">
        <path
          d="M52.92 100.142c-20.109 26.163-35.272 56.318-44.101 89.077h133.178L52.92 100.142zM503.181 189.219c-8.829-32.758-23.993-62.913-44.101-89.076l-89.075 89.076h133.176zM8.819 322.784c8.83 32.758 23.993 62.913 44.101 89.075l89.074-89.075H8.819zM411.858 52.921c-26.163-20.109-56.317-35.272-89.076-44.102v133.177l89.076-89.075zM100.142 459.079c26.163 20.109 56.318 35.272 89.076 44.102V370.005l-89.076 89.074zM189.217 8.819c-32.758 8.83-62.913 23.993-89.075 44.101l89.075 89.075V8.819zM322.783 503.181c32.758-8.83 62.913-23.993 89.075-44.101l-89.075-89.075v133.176zM370.005 322.784l89.075 89.076c20.108-26.162 35.272-56.318 44.101-89.076H370.005z"></path>
      </g>
      <g fill="#D80027">
        <path
          d="M509.833 222.609H289.392V2.167A258.556 258.556 0 00256 0c-11.319 0-22.461.744-33.391 2.167v220.441H2.167A258.556 258.556 0 000 256c0 11.319.744 22.461 2.167 33.391h220.441v220.442a258.35 258.35 0 0066.783 0V289.392h220.442A258.533 258.533 0 00512 256c0-11.317-.744-22.461-2.167-33.391z"></path>
        <path
          d="M322.783 322.784L437.019 437.02a256.636 256.636 0 0015.048-16.435l-97.802-97.802h-31.482v.001zM189.217 322.784h-.002L74.98 437.019a256.636 256.636 0 0016.435 15.048l97.802-97.804v-31.479zM189.217 189.219v-.002L74.981 74.98a256.636 256.636 0 00-15.048 16.435l97.803 97.803h31.481zM322.783 189.219L437.02 74.981a256.328 256.328 0 00-16.435-15.047l-97.802 97.803v31.482z"></path>
      </g>
    </svg>
  )
}

export const FlagENSquareSvg = ({size = 20, ...props}) => {
  return (
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 512 512"
          xmlSpace="preserve"
          {...props}>
        <path fill="#f0f0f0" d="M0 85.333H512V426.66999999999996H0z" />
        <path
            fill="#d80027"
            d="M288 85.33L224 85.33 224 223.996 0 223.996 0 287.996 224 287.996 224 426.662 288 426.662 288 287.996 512 287.996 512 223.996 288 223.996z"
        />
        <g fill="#0052b4">
          <path d="M393.785 315.358L512 381.034 512 315.358z" />
          <path d="M311.652 315.358L512 426.662 512 395.188 368.307 315.358z" />
          <path d="M458.634 426.662L311.652 344.998 311.652 426.662z" />
        </g>
        <path
            fill="#f0f0f0"
            d="M311.652 315.358L512 426.662 512 395.188 368.307 315.358z"
        />
        <path
            fill="#d80027"
            d="M311.652 315.358L512 426.662 512 395.188 368.307 315.358z"
        />
        <g fill="#0052b4">
          <path d="M90.341 315.356L0 365.546 0 315.356z" />
          <path d="M200.348 329.51L200.348 426.661 25.491 426.661z" />
        </g>
        <path
            fill="#d80027"
            d="M143.693 315.358L0 395.188 0 426.662 0 426.662 200.348 315.358z"
        />
        <g fill="#0052b4">
          <path d="M118.215 196.634L0 130.958 0 196.634z" />
          <path d="M200.348 196.634L0 85.33 0 116.804 143.693 196.634z" />
          <path d="M53.366 85.33L200.348 166.994 200.348 85.33z" />
        </g>
        <path
            fill="#f0f0f0"
            d="M200.348 196.634L0 85.33 0 116.804 143.693 196.634z"
        />
        <path
            fill="#d80027"
            d="M200.348 196.634L0 85.33 0 116.804 143.693 196.634z"
        />
        <g fill="#0052b4">
          <path d="M421.659 196.636L512 146.446 512 196.636z" />
          <path d="M311.652 182.482L311.652 85.331 486.509 85.331z" />
        </g>
        <path
            fill="#d80027"
            d="M368.307 196.634L512 116.804 512 85.33 512 85.33 311.652 196.634z"
        />
      </svg>
  )
}
